import { useRequest } from 'features/request/useRequest';
import { RatioTypeEnum } from 'gql/graphql';
import { useAgGridDataSource } from 'hooks/useAgGridDataSource';
import { useProjectData } from 'hooks/useProjectData';

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { priceListUerForTechPartRatioGql } from '../applicationAreaSelectorQueries';

import { usePriceListForUerTableVariables } from './usePriceListForUerTableVariables';

export interface IUseUerRatioSelectorData {
    searchValue: string;
    currentFilters: Record<string, string[]> | null;
}

export const usePriceListUerForTechPartRatioData = (props: IUseUerRatioSelectorData) => {
    const { searchValue, currentFilters } = props;
    const { id: projectId } = useParams();
    const { projectData } = useProjectData(projectId);

    const variables = usePriceListForUerTableVariables({
        searchValue,
        currentFilters,
        contractId: projectData?.contractId,
        ratioType: RatioTypeEnum.TechPartCoef,
    });

    const [priceListUerForTechPartRatioData, , , request] = useRequest({
        requestId: 'uerPriceListRatio',
        query: priceListUerForTechPartRatioGql,
        withEffect: false,
    });

    const { dataSource, getRowParams } = useAgGridDataSource({
        requestId: 'uerPriceListRatio',
        requestFn: request,
        requestVariables: variables,
    });

    useEffect(() => {
        if (priceListUerForTechPartRatioData?.uerPriceListUerForTechPartRatio?.items && getRowParams?.current) {
            getRowParams?.current?.successCallback(
                priceListUerForTechPartRatioData?.uerPriceListUerForTechPartRatio?.items,
                priceListUerForTechPartRatioData?.uerPriceListUerForTechPartRatio?.totalCount,
            );
        }
    }, [
        getRowParams,
        priceListUerForTechPartRatioData?.uerPriceListUerForTechPartRatio?.items,
        priceListUerForTechPartRatioData?.uerPriceListUerForTechPartRatio?.totalCount,
    ]);

    return {
        dataSource,
    };
};
